import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CouponModel } from 'src/app/models/coupon-model';
import { CustomerAddress } from 'src/app/models/customer-address';
import { ItemDisplayData } from 'src/app/models/item-display-data';
import { CouponsService } from 'src/app/services/coupons.service';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-order-resume',
  templateUrl: './order-resume.component.html',
  styleUrls: ['./order-resume.component.scss']
})
export class OrderResumeComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  currentPriceString:string = '';
  orderModeString:string = '';
  orderModeMessage:string = '';
  showOrderModeMessage:boolean = false;
  fullName:string = '';
  phone:string = '';
  itemList:Array<ItemDisplayData> = new Array<ItemDisplayData>();
  hasItem:boolean = false;
  isLoading:boolean = false;
  isError:boolean = false;
  orderMode:number = -1;
  adress:CustomerAddress | undefined;
  baseData:any;
  carDescription:any;
  hasFee:boolean = false;
  feeString:string = '';
  changeString:string = '';
  waitTimeString:string = '';
  payCardString:string = '';
  coupon:CouponModel | undefined;

  constructor
  (
    private initializationservice:InitializationService, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private router:Router,
    private customerservice:CustomerService,
    private workweekservice:WorkWeekService,
    private currentinfoservice:CurrentInfoService,
    public alertDialog: MatDialog,
    private localeservice: LocaleService,
    private analyticsservice: AnalyticsService,
    private couponservice: CouponsService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.baseData = this.currentorderservice.getBaseData();

    this.orderMode = this.currentorderservice.getOrderType();

    this.orderModeString = this.currentorderservice.GetRetrievalModeString( this.orderMode);
    this.fullName = this.customerservice.getCustomerName();
    this.phone = this.customerservice.getCustomerPhone();

    this.adress = this.currentorderservice.getCurrentAdress();
    this.hasFee = this.currentorderservice.hasFee();

    this.coupon = this.currentorderservice.getCoupon();
    
    if(this.hasFee === true)
      this.feeString = this.currentorderservice.getFeeString();

    this.currentPriceString = this.currentorderservice.getCurrentPriceString(true, true);
    this.itemList = this.currentorderservice.getOrderItensDisplayData();
    this.hasItem = this.currentorderservice.getOrderItemCount() > 0;

    if((this.orderMode === 2 || this.orderMode === 4) && this.baseData.needschange === 1)
      this.changeString = this.localeservice.getCurrencyString(this.baseData.changefor);

    if(this.orderMode === 4)
      this.carDescription = this.currentorderservice.getCarDescription();

    this.waitTimeString = this.currentorderservice.getWaitTimeString();

    var payCardData = this.currentorderservice.getPayCardData();

    if(payCardData && this.orderMode === 0)
    {
      if(payCardData.hasPayCard === 0)
        this.payCardString = this.localeservice.instantTranslation("Pages.OrderResume.Info.NewPayCard");
      else if(payCardData.hasPayCard === 1)
        this.payCardString = this.localeservice.instantTranslation("Pages.OrderResume.Info.PayCard") + String(payCardData.payCardNumber);
    }
  }

  back()
  {
    this.navigationservice.back();
  }

  changeAdress()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + '/adresspicker?origin=orderresume');
  }
 
  async sendOrder()
  {
    this.isLoading = true;

    var result = await this.currentorderservice.sendOrder();

    if(result === true)
    {
      this.analyticsservice.facebookTrack('OrderSent', undefined );
      this.analyticsservice.track('OrderSent', { path:this.initializationservice._appName });

      this.currentorderservice.clear();

      this.currentorderservice.setShowOrderSent();

      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname);
    }
    else
      this.isError = true;

    this.isLoading = false;
  }

  tryAgain()
  {
    this.isError = false;

    this.sendOrder();
  }
}
